module.exports = __webpack_public_path__ + "static/media/shadow.40f01aaf.png";